import { Grid, Typography, Box } from "@mui/material";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import CustomBox from "../Common/CustomBox";
import LitigantBox from "../Common/LitigantBox";
import FAQ from "../Common/FAQ";
import CircleChart from "../Common/CircleChart";
import { useState, useEffect } from "react";
import ProgressBarTempo from "../Common/ProgressBarTempo";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";

let faqsStatic = [
  {
    content: "Are there washrooms for men?",
    status: "Yes",
  },
  {
    content: "Are there washrooms for women?",
    status: "Yes",
  },
  {
    content: "Is there running water in the washroom?",
    status: "No",
  },
  {
    content: "Did you see housekeeping staff inside or near the toilet area?",
    status: "No",
  },
  {
    content:
      "Did you see a cleaning chart somewhere inside the toilet to indicate periodic cleaning?",
    status: "No",
  },
];

export const Hygiene = ({ dataState, dataDistrict, selectedDistrict }) => {
  const { theme, loader } = useCustomLogic();
  let isDistrict = selectedDistrict === "Select District";

  const [faqs, setFaqs] = useState(faqsStatic);
  const [chartData, setChartData] = useState([]);
  const [washroomPresent, setWashroomPresent] = useState(10);
  const [maleFemalePresent, setMaleFemalePresent] = useState(10);
  const [functionWashroomPresent, setFunctionWashroomPresent] = useState(10);
  const [dotGraphKey, setDotGraphKey] = useState(1);

  useEffect(() => {
    if (dataState && Object.keys(dataState).length > 0) {
      let data = [
        dataState?.running_water ?? 0,
        dataState?.flush ?? 0,
        dataState?.soap ?? 0,
        dataState?.tissue ?? 0,
        dataState?.mirror ?? 0,
        dataState?.fan ?? 0,
      ];
      setChartData(data);

      setWashroomPresent(dataState?.male);
      setMaleFemalePresent(dataState?.both_genders);
      setFunctionWashroomPresent(dataState?.fully_functional);
    }

    if (dataDistrict && Object.keys(dataDistrict).length > 0) {
      let arr = [
        dataDistrict?.washroom_for_men ?? "",
        dataDistrict?.washroom_for_women ?? "",
        dataDistrict?.toilet_has_running_water ?? "",
        dataDistrict?.toilet_cleaning_staff_present ?? "",
        dataDistrict?.cleaning_chart_present ?? "",
      ];

      setFaqs(faqsStatic.map((item, index) => ({ ...item, status: arr[index] })));

      //   setting chart data for district
      if (!isDistrict) {
        let data = [
          dataDistrict?.running_water ?? 0,
          dataDistrict?.flush ?? 0,
          dataDistrict?.soap ?? 0,
          dataDistrict?.tissue ?? 0,
          dataDistrict?.mirror ?? 0,
          dataDistrict?.fan ?? 0,
        ];
        setChartData(data);
      }
    }
    setDotGraphKey(Math.random());
  }, [dataState, dataDistrict, selectedDistrict]);

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {isDistrict ? (
            <>
              <Typography variant="regular3" color="secondary.main">
                Are there clean, fully functional washrooms?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: "10px",
                  textAlign: "left",
                  letterSpacing: "0.2px",
                  wordSpacing: "1px",
                }}
              >
                A fully functional washroom implies that washrooms are present for men and women,
                and had running water, cleaning charts or cleaning staff inside or near the
                washrooms. Litigants were also asked to give suggestions for improving washrooms.
              </Typography>
              <Grid container sx={{ justifyContent: "center", gap: "10px", my: "20px" }}>
                {/* <Grid item md={4} xs={4} lg={4} sm={4}> */}
                <ProgressBarTempo Percentage={washroomPresent} text={"Washrooms Present"} />
                {/* </Grid> */}
                {/* <Grid item md={4} xs={4} lg={4} sm={4}> */}
                <ProgressBarTempo
                  Percentage={maleFemalePresent}
                  text={"Male & Female Washrooms Present"}
                />
                {/* </Grid> */}
                {/* <Grid item md={4} xs={4} lg={4} sm={4}> */}
                <ProgressBarTempo
                  Percentage={functionWashroomPresent}
                  text={"Fully Functioning Washrooms"}
                />
                {/* </Grid> */}
              </Grid>
            </>
          ) : (
            <>
              <CustomBox
                content="Are there clean, fully-functional washrooms?"
                style={{
                  fontSize: "24px",
                  padding: "8px 13px",
                  color: theme.palette.common.black,
                  backgroundColor: "#e6ebf4",
                }}
              />

              {faqs &&
                faqs.map((elem, index) => {
                  return (
                    <FAQ
                      content={elem?.content}
                      status={elem?.status}
                      isLastItem={index === faqs.length - 1}
                    />
                  );
                })}
            </>
          )}

          <LitigantBox mt={!isDistrict && "26px"} mb={!isDistrict && "0px"} />
          <CustomBox
            mt={!isDistrict && "0px"}
            mb="20px"
            content="WHAT CAN BE ADDED TO MAKE WASHROOMS MORE USABLE?"
          />
          {chartData.length > 0 && <CircleChart data={chartData} key={dotGraphKey} />}
        </Box>
      )}
    </>
  );
};
